import {Link} from '@dsco_/link';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';

import colorUtil from '@cdo/apps/util/color';

import {embedBlocklyBlock} from './utils/embeddedBlocklyRenderUtils';

export const NavigationItem = ({
  text,
  href,
  indentLevel = 0,
  isActive = false,
  blockName,
}) => {
  const blockRef = React.createRef();

  useEffect(() => {
    if (blockName && blockRef.current) {
      embedBlocklyBlock(blockRef.current, blockName);
    }
  }, [blockName, blockRef]);

  return (
    <div
      style={{paddingLeft: `${indentLevel * 12}px`}}
      className={classNames({
        'nav-link': true,
        active: isActive,
      })}
    >
      <Link className="link" href={href} weight="medium">
        {blockName ? <div ref={blockRef} /> : text}
      </Link>
    </div>
  );
};

NavigationItem.propTypes = {
  text: PropTypes.node.isRequired,
  href: PropTypes.string.isRequired,
  indentLevel: PropTypes.number,
  isActive: PropTypes.bool,
  blockName: PropTypes.string,
  programmingEnvironmentName: PropTypes.string,
};

export const NavigationCategory = ({
  name,
  color = colorUtil.teal,
  initialIsOpen = false,
  useColorWhenClosed = false,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(initialIsOpen || false);
  const backgroundColor =
    useColorWhenClosed || isOpen ? color : colorUtil.lightest_gray;
  const textColor =
    useColorWhenClosed || !isOpen ? colorUtil.dimgray : colorUtil.white;
  return (
    <div
      style={{
        backgroundColor,
        color: textColor,
      }}
      className={classNames({
        category: true,
        open: isOpen,
        'transition-color': isOpen && !useColorWhenClosed,
      })}
    >
      <span
        className="title"
        tabIndex="0"
        role="button"
        onClick={() => setIsOpen(!isOpen)}
        onKeyDown={e => {
          if ([' ', 'Enter', 'Spacebar'].includes(e.key)) {
            setIsOpen(!isOpen);
          }
        }}
      >
        {name}
      </span>
      {children}
    </div>
  );
};
NavigationCategory.propTypes = {
  name: PropTypes.string.isRequired,
  color: PropTypes.string,
  useColorWhenClosed: PropTypes.bool,
  initialIsOpen: PropTypes.bool,
  children: PropTypes.node,
};

export const NavigationBar = ({children}) => {
  return <div className="nav-bar header">{children}</div>;
};

NavigationBar.propTypes = {
  children: PropTypes.node,
};
